import { RtspConfig } from 'types/rtsp_config';

export const STREAM_SOURCES = [
  'uri_stream',
  'camera_stream',
  'pipeline_stream',
] as const;
export type StreamSource = (typeof STREAM_SOURCES)[number];

export const STREAM_TYPES = ['rtsp', 'webrtc', 'file'] as const;
export type StreamType = (typeof STREAM_TYPES)[number];

export const STREAM_STATES = ['offline', 'online', 'unknown'] as const;
export type StreamState = (typeof STREAM_STATES)[number];

export function isStreamState(state: string): state is StreamState {
  return ([...STREAM_STATES] as string[]).includes(state);
}

export function getStreamStatusHelpText(stream: Stream): string {
  const helpTextByState: Record<StreamState, string> = {
    online: 'Stream is online.',
    offline: 'Stream is offline. Please check the stream source.',
    unknown: stream.gateway_id
      ? 'Stream status is unknown because its Gateway is offline.'
      : 'Stream status is unknown because it is not assigned to a Gateway. Assign it to a Gateway in Stream settings to monitor status.',
  };

  return helpTextByState[stream.status];
}

export type Stream = {
  readonly id: string;
  name: string;
  application_id: string;
  source: StreamSource;
  stream_type: StreamType;
  status: StreamState;
  uri: string;
  gateway_id: string | null;
  camera_id: string | null;
  deployment_id: string | null;
  node: string | null;
  snapshot_file_id: string | null;
  insecure_disable_tls_verification: boolean;
  rtsp_config: RtspConfig | null;
  tags: string[];
  readonly created_at: string;
  readonly updated_at: string;
};
